import { combineReducers } from "redux";
import auth from "./modules/auth";
import bookings from "./modules/bookings";
import cards from "./modules/cards";
import detailFlight from "./modules/detailFlight";
import detailHotel from "./modules/detailHotel";
import loading from "./modules/loading";
import passengers from "./modules/passengers";
import paymentPlan from "./modules/paymentPlan";
import referrals from "./modules/referrals";
import search from "./modules/search";

export default combineReducers({
	search,
	loading,
	passengers,
	detailFlight,
	referrals,
	detailHotel,
	paymentPlan,
	auth,
	bookings,
	cards,
});
